/*
 * See the file LICENSE for the full license governing this code.
 */

import React from 'react';
import LogoImg from './logo.png';
import Skeleton from '@mui/material/Skeleton';

const logoSize = { width: 301, height: 73 };

function Logo({ style = {} }) {
  const [loaded, setLoaded] = React.useState(false);
  return (
    <>
      {loaded ? null : <Skeleton variant="rectangular" {...logoSize} />}
      <img
        style={loaded ? style : { display: 'none' }}
        alt="logo"
        onLoad={() => {
          setLoaded(true);
        }}
        src={LogoImg}
      ></img>
    </>
  );
}

export default Logo;
